/**
 * Maps source data fields to target form.
 * Excludes auto-generated fields.
 * Only returns fields that should be set in the form.
 */
export const mapToTargetForm = (sourceData, notification) => {
  if (!sourceData || !notification) return {};

  const excludeFields = ['id', 'createdAt', 'updatedAt', 'lastModifiedBy', 'createdBy', 'createdDate', 'modifiedDate', 'dartaaMiti'];

  const mapped = {};

  Object.keys(sourceData).forEach(field => {
    if (excludeFields.includes(field)) return;
    if (sourceData[field] !== undefined && sourceData[field] !== null && sourceData[field] !== "") {
      mapped[field] = sourceData[field];
    }
  });

  return mapped;
};
